import { render, staticRenderFns } from "./council_details.vue?vue&type=template&id=4b4f3ccd&scoped=true&"
import script from "./council_details.vue?vue&type=script&lang=js&"
export * from "./council_details.vue?vue&type=script&lang=js&"
import style0 from "./council_details.vue?vue&type=style&index=0&id=4b4f3ccd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4f3ccd",
  null
  
)

export default component.exports